/**
 * Helpers de cookie — portados de [application.js:824 getCookie / 839 setCookie].
 *
 * Os cookies `userId`/`email` são COMPARTILHADOS com a extensão Chrome
 * (a extensão os grava; o painel os lê). Manter nomes/domínios/paths idênticos.
 */

export function getCookie(name: string): string | undefined {
  try {
    const nameEQ = name + '=';
    const parts = document.cookie.split(';');
    for (const raw of parts) {
      let c = raw;
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return undefined;
  } catch {
    return undefined;
  }
}

/**
 * Escreve cookie no domínio da marca (mesma estratégia do legado: `.eminer.app` /
 * `.maquinadeleads.com`). Usado com parcimônia — a extensão é a fonte de verdade de auth.
 */
export function setCookie(name: string, value: string, days = 365): void {
  try {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = '; expires=' + date.toUTCString();
    const host = window.location.hostname;
    let domain = '';
    if (host.includes('eminer.app')) domain = '; domain=eminer.app';
    else if (host.includes('maquinadeleads.com')) domain = '; domain=maquinadeleads.com';
    document.cookie = `${name}=${value ?? ''}${expires}${domain}; path=/`;
  } catch {
    /* noop */
  }
}
